import type { AddOnRequestListResponse } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";
import type { GetAddOnRequestsParams } from "./types";

export const QUERY_KEY = "getAddOnRequests";

export const getQueryKey = (participantId: string, params: GetAddOnRequestsParams) =>
  [QUERY_KEY, participantId, params] as const;

export const useGetAddOnRequests = <TData = AddOnRequestListResponse>(
  participantId: Ref<string | undefined> | string,
  params?: Ref<GetAddOnRequestsParams | undefined> | GetAddOnRequestsParams,
  useQueryOptions?: Partial<UseQueryOptions<AddOnRequestListResponse, Error, TData>>,
) => {
  const requestParams = computed(() => ({
    limit: unref(params)?.limit,
    skip: unref(params)?.skip,
    get_archived: unref(params)?.get_archived,
  }));

  const fetchAddOnRequests = (): Promise<AddOnRequestListResponse> =>
    learningServiceRequest({
      method: "get",
      url: `/add_ons/request/${unref(participantId)}/`,
      params: requestParams.value,
    }).then((response: AxiosResponse<AddOnRequestListResponse>) => response.data);

  return useQuery<AddOnRequestListResponse, Error, TData>({
    queryKey: computed(() => getQueryKey(unref(participantId) ?? "", requestParams.value)),
    queryFn: fetchAddOnRequests,
    ...useQueryOptions,
  });
};
